export default "__VITE_ASSET__BzBqTdWS__"